<template>
  <section class="viewsrhqyAppointDelivery_DeliveryRecordDetail p-4 space-y-2">
    <viewTitle
      title="业务管理 / 预约记录管理 / 预约提货记录 / 预约提货记录详情"
      :showReturn="true"
    >
      <template slot="return">
        <el-button
          class="w-20"
          @click="$router.go(-1)"
          plain
          size="small"
          style="font-size: 14px;"
          >返回</el-button
        >
        <el-button
          v-if="![8, 7].includes(detail.state)"
          class="w-20"
          @click="onClose"
          v-has="['c-booking-pickup-close']"
          size="small"
          type="danger"
          >关闭</el-button
        >
      </template>
    </viewTitle>
    <el-row>
      <el-form :model="detail" :label-width="labelWidth">
        <!-- 左边 -->
        <el-col :span="10">
          <div class="text-lg">基本信息</div>
          <el-form-item v-if="detail.ship_name" label="木片厂名">
            <span class="text-gray-500">{{ detail.ship_name || "--" }}</span>
          </el-form-item>
          <el-form-item label="客户名称">
            <span class="text-gray-500">{{
              detail.supplier_name || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="客户编号">
            <span class="text-gray-500">{{
              detail.supplier_code || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="基地">
            <span class="text-gray-500">{{ detail.company_name || "--" }}</span>
          </el-form-item>
          <el-form-item label="申请时间">
            <span class="text-gray-500">{{
              moment.unix(detail.create_time).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </el-form-item>
          <el-form-item label="分类">
            <span class="text-gray-500">{{ pickupCategoryDisplay }}</span>
          </el-form-item>
          <el-form-item label="车辆类型">
            <span class="text-gray-500">{{ pickupVehicleModeDisplay }}</span>
          </el-form-item>
          <el-form-item label="车辆业务类型">
            <span
              class="text-gray-500"
              v-for="item in detail.business.sub_business"
              :key="item.id"
            >
              {{ item.name }}
            </span>
          </el-form-item>

          <div class="text-lg">预约信息</div>
          <el-form-item label="预约号">
            <span class="text-gray-500">{{ detail.code || "--" }}</span>
          </el-form-item>
          <el-form-item label="预约状态">
            <span class="text-gray-500">{{
              businessState[detail.state] || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="司机手机号">
            <span class="text-gray-500">{{ detail.info.contact || "--" }}</span>
          </el-form-item>
          <el-form-item label="提货日期">
            <span class="text-gray-500">{{
              moment(detail.booking_day, "YYYYMMDD").format("YYYY-MM-DD") ||
                "--"
            }}</span>
          </el-form-item>
          <el-form-item label="提货时间段">
            <span class="text-gray-500">
              {{ detail.booking_time.begin_time }} ~
              {{ detail.booking_time.end_time }}
            </span>
          </el-form-item>
          <template v-if="isTriWastePickup">
            <el-form-item label="装运单号">
              <span class="text-gray-500">{{ detail.waybill_code || "--" }}</span>
            </el-form-item>
            <el-form-item label="装运单行号">
              <span class="text-gray-500">{{ detail.order_item || "--" }}</span>
            </el-form-item>
            <el-form-item label="销售订单号">
              <span class="text-gray-500">{{ detail.order_code || "--" }}</span>
            </el-form-item>
            <el-form-item label="物料编码">
              <span class="text-gray-500">{{ detail.chip_code || "--" }}</span>
            </el-form-item>
            <el-form-item label="物料描述">
              <span class="text-gray-500">{{ detail.chip_type || "--" }}</span>
            </el-form-item>
          </template>

          <div class="text-lg">车辆信息</div>
          <el-form-item label="车牌号">
            <span class="text-gray-500">
              {{ detail.info.license_plate || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="车辆类型">
            <span class="text-gray-500">
              {{ detail.info.vehicle_type | formatVehicleType(vehicleTypes) }}
            </span>
          </el-form-item>
          <el-form-item label="司机姓名">
            <span class="text-gray-500">
              {{ detail.info.name || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="身份证号">
            <span class="text-gray-500">
              {{ detail.info.id_card || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="副驾姓名">
            <span class="text-gray-500">
              {{ firstReportEntourage.name || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="副驾手机号">
            <span class="text-gray-500">
              {{ firstReportEntourage.contact || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="副驾身份证号">
            <span class="text-gray-500">
              {{ firstReportEntourage.id_card || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="货物种类">
            <span class="text-gray-500">
              {{ detail.business_goods_name || "--" }}
            </span>
          </el-form-item>
          <el-form-item v-if="!isTriWastePickup" label="运单号">
            <span class="text-gray-500">
              {{ detail.waybill_code || "--" }}
            </span>
          </el-form-item>
        </el-col>
        <!-- 右边 -->
        <el-col :span="14">
          <template v-if="detail.queue">
            <span class="text-lg">排队信息</span>
            <el-form-item label="进厂前排队">
              <span class="text-gray-500">
                总排队：{{ detail.queue.total_seq }}（<span
                  class="text-gray-500"
                  v-for="item in detail.business.sub_business"
                  :key="item.id"
                >
                  {{ item.name }} </span
                >：{{ detail.queue.business_seq }}）
              </span>
            </el-form-item>
          </template>
          
          <div class="text-lg">变更日志</div>
          <el-form-item
            v-for="item in detail.log"
            :key="item.id"
            label-width="50px"
          >
            <span class="text-gray-500">
              <span v-html="item.note"></span>（{{
                item.create_time | timeFormat
              }}）
            </span>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  props: [],

  data() {
    return {
      moment,
      labelWidth: "120px",
      detail: {
        clock: {},
        info: {},
        business: {
          sub_business: []
        },
        booking_time: {},
        file: [],
        log: [],
        queue: {},
        // 关键步骤：Vue 2 需要在初始化时声明详情扩展字段，避免接口回填后 computed 仍缓存为默认值。
        pickup_category: "",
        pickup_vehicle_mode: ""
      },
      stateList: [
        { label: "待出车", value: "0" },
        { label: "待登记", value: "1" },
        { label: "待授权", value: "41" },
        { label: "待叫号", value: "42" },
        { label: "待进厂", value: "43" },
        { label: "待入厂磅", value: "48" },
        { label: "待测水", value: "49" },
        { label: "待取样", value: "44" },
        { label: "待装卸", value: "45" },
        { label: "待出厂", value: "46" },
        { label: "已完成", value: "8" },
        { label: "已过号", value: "47" },
        { label: "已关闭", value: "7" }
      ]
    };
  },

  computed: {
    ...mapGetters(["businessState", "vehicleTypes"]),
    // 预约提货详情页优先回显预约时保存的分类，避免调度人员误把业务类型当成提货分类。
    pickupCategoryDisplay() {
      return this.detail.pickup_category || "--";
    },
    // 成品提货的“车辆类型”来自预约上下文，不等于司机档案里的车型字段。
    pickupVehicleModeDisplay() {
      return this.detail.pickup_vehicle_mode || "--";
    },
    // 关键步骤：三废字段由 SAP 装运单生成，只在三废预约详情中展示，避免成品提货详情出现空字段。
    isTriWastePickup() {
      return this.detail.pickup_category === "三废";
    },
    // 预约提货详情页固定展示首位副驾，保持与送货详情页一致的展示口径。
    firstReportEntourage() {
      const reportEntourage = this.detail.report_entourage;
      if (!Array.isArray(reportEntourage) || reportEntourage.length === 0) {
        return {};
      }

      return reportEntourage[0] || {};
    }
  },

  watch: {},

  components: {},

  mixins: [],

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  activated() {},

  filters: {
    timeFormat(time, style = "YYYY-MM-DD HH:mm:ss") {
      return time ? moment.unix(time).format(style) : "--";
    },
    formatLicensePlateType(type) {
      const map = {
        1: "蓝牌车",
        2: "黄牌车",
        3: "黄绿车"
      };
      return map[type] || "--";
    },
    formatVehicleType(type, data) {
      const typeItem = data.find(e => e.id == type);
      if (typeItem) {
        return typeItem.name;
      }
      return "--";
    }
  },

  deactivated() {},

  methods: {
    // 获取预约提货详情，并保留后端返回的预约上下文字段供页面直接展示。
    async getDetail() {
      const res = await this.$common.http({
        url: "/api/queue/admin/query_booking_detail",
        data: {
          booking_info_id: this.$route.params.booking_info_id
        }
      });
      // 关键步骤：沿用现有 detail 容器补齐接口字段，避免模板里旧字段引用被新对象清空。
      this.detail = Object.assign(this.detail, res.data.data);
    },
    // 关闭当前预约提货记录。
    onClose() {
      this.$confirm("确认关闭此预约提货记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await this.$common.http({
          url: "/api/queue/admin/close",
          data: {
            booking_id: this.detail.id
          }
        });
        // this.$common.pcToastSuccess("关闭预约记录成功！");
        // this.getDetail();
        location.reload();
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="less" scoped>
.viewsrhqyAppointDelivery_DeliveryRecordDetail {
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
</style>
